/**
 * D-502 (CU-14zefhy1r1w): CoPilot calls (`api/assistant/**`) never open the app-wide error dialog or warning toast: the
 * chat shows its own message (e.g. while PythonMagic restarts and the API answers 502/503). Only the URL path counts.
 */
export function isAssistantApiUrl(url: string | null | undefined): boolean {
    if (!url) {
        return false;
    }
    const path = url.split(/[?#]/)[0];
    return /(^|\/)api\/assistant(\/|$)/.test(path);
}
